<!--
  ~ Copyright (c) GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div id="header-container">
  <h1 id="header-text">{{ title }}</h1>
  <div id="actions-container">
    <button mat-stroked-button id="cancel-button" class="action-button" mat-dialog-close>Close</button>
  </div>
</div>
<div class="default-padding">
  <mat-tab-group (selectedTabChange)="onTabChangeEvent($event)" mat-stretch-tabs="false">
    <mat-tab *ngFor="let element of tabKeys" label="{{element}}" class="set-height">
    </mat-tab>
  </mat-tab-group>
  <div class="set-height">

    <ag-grid-angular
      style="height: 100%;"
      class="ag-theme-quartz"
      [rowData]="displayedData"
      [columnDefs]="colDef"
      [autoSizeStrategy]="autoSizeStrategy"
      (gridReady)="onGridReady($event)"
    />
  </div>
</div>
